// Pass commit as undefined to disable loading logic
// Config: commit, method, url, data, successCallback
export default function(config) {
  if (config.commit !== undefined) config.commit('CHANGE_LOADING_STATE', true)
  return new Promise((resolve, reject) => {
    var axiosConfig = {
      method: config.method,
      url: config.url,
      data: config.data
    };
    if (config.multipart)
      axiosConfig.headers = {
        'Content-Type': 'multipart/form-data'
      }
      
    axios(axiosConfig).then(response => {
      if (response.data.success === true) {
        config.successCallback(response.data.data)
        resolve(config.includeData === true ? response.data : response.data.message)
      } else {
        reject(response.data.message)
      }
      if (config.commit !== undefined) config.commit('CHANGE_LOADING_STATE', false)
    }).catch(error => {
      if (config.commit !== undefined) {
        config.commit('CHANGE_LOADING_STATE', false)
        if (error.response != undefined && error.response.status == 401)
          config.commit('users/SET_USER', null, { root: true })
      }
      if (error.response != undefined && error.response.data != undefined)
        reject(error.response.data.message)
      else if (error)
        reject(error)
    })
  })
}